import { jsonFetch } from "@/lib/helpers";
import { ALARM_RULES_URL } from "./api-url.constants";
import { AlarmRuleDTO, CreateAlarmRuleBodyDTO } from "./dtos";
import { API_METHODS } from "../shared";

type CreateAlarmRuleResponse = {
  data: AlarmRuleDTO;
};

export const createAlarmRule = async (body: CreateAlarmRuleBodyDTO): Promise<AlarmRuleDTO> => {
  const response = await jsonFetch<CreateAlarmRuleResponse>(ALARM_RULES_URL, {
    method: API_METHODS.POST,
    body: JSON.stringify(body),
  });
  return response.data;
};
